<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
  >
    <div class="df vertical">
      <div>未添加菜单:&nbsp;&nbsp;</div>
      <a-select
        placeholder="未添加菜单"
        @change="handleSelectDeduplica"
        allowClear
        v-model:value="deduplica"
      >
        <template v-for="(item, index) in routerOptions.deduplica">
          <a-select-option :value="item.name">
            {{ item.name }}
          </a-select-option>
        </template>
      </a-select>
    </div>

    <a-form
      ref="formRef"
      :model="formState"
      :rules="rules"
      :label-col="{ style: { width: '80px' } }"
    >
      <a-form-item label="id">
        <a-input placeholder="id" v-model:value="formState.id"></a-input>
      </a-form-item>

      <a-form-item label="pid">
        <a-input v-model:value="formState.pid" placeholder="pid"> </a-input>

        <a-select v-model:value="formState.pid" placeholder="pid">
          <template v-for="(item, index) in routerOptions.serve">
            <a-select-option :value="item.id">
              {{ item.name }}
            </a-select-option>
          </template>
        </a-select>
      </a-form-item>

      <a-form-item label="图标" name="icon">
        <a-input v-model:value="formState.icon" placeholder="图标"></a-input>
      </a-form-item>

        

      <a-form-item label="权限名称" name="name">
        <a-input
          v-model:value="formState.name"
          placeholder="权限名称"
        ></a-input>
      </a-form-item>

      <a-form-item label="排序" name="sort">
        <a-input v-model:value="formState.sort" placeholder="排序"></a-input>
      </a-form-item>
      <a-form-item label="权限类型" name="type">
        <a-input
          v-model:value="formState.type"
          placeholder="权限类型"
        ></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { defineComponent, reactive, ref, watch } from "vue";
import { Toast } from "@/utils";
import { routerArr } from "@/utils/base/getMenu";
import {
  saveOrUpdatePermission,
  getPermissionTree,
} from "@/request/view/permissions";

export default defineComponent({
  setup(props, context) {
    const routerOptions = reactive({
      // 本地存在菜单未添加的路由
      deduplica: [],
      // 现有的菜单
      serve: [],
      // 本地的路由
      local: [],
    });

    const deduplica = ref(null);
    //

    const formState = reactive({
      icon: null,
      name: null,
      sort: null,
      identify: null,
      type: null,
      id: null,
      pid: null,
    });

    const rules = {
      icon: [{ required: true, message: null, trigger: "change" }],
      name: [{ required: true, message: null, trigger: "change" }],
      sort: [{ required: true, message: null, trigger: "change" }],
      type: [{ required: true, message: null, trigger: "change" }],
    };
    const modalConfig = reactive({
      visible: false,
      title: null,
    });

    const flatList = (list) => {
      const flatList = [];
      const ite = (arr) => {
        arr.forEach((item) => {
          if (item.type != 2) {
            flatList.push({
              identify: item.identify || item.path,
              name: item.name,
              type: 1,
              id: item.id,
              pid: item.pid,
            });
          }

          if (item.children) {
            ite(item.children);
          }
        });
      };
      ite(list);
      return flatList;
    };

    const resetOptions = () => {
      getPermissionTree().then((res) => {
        if (res.code === 200 && res.message === "成功") {
          const serverRouteList = flatList(res.data);
          const localRouteList = flatList(routerArr[0].children);

          const deduplicaArr = [];

          localRouteList.forEach((item) => {
            const serverHasRoute = serverRouteList.find(
              (f) => f.identify === item.identify
            );

            if (!serverHasRoute) {
              deduplicaArr.push(item);
            } else {
              item.name = serverHasRoute.name;
            }
          });

          routerOptions.deduplica.length = 0;
          routerOptions.serve.length = 0;
          routerOptions.local.length = 0;

          routerOptions.deduplica.push(...deduplicaArr);
          routerOptions.serve.push(...serverRouteList);
          routerOptions.local.push(...localRouteList);

          console.log(routerOptions, "routerOptions");
        }
      });
    };

    const showModal = (type, options) => {
      //   const { title, data } = options;
      //   if (type === "update") {
      //     Object.keys(formState).forEach((key) => {
      //       formState[key] = data[key];
      //     });
      //   }
      //   if (type === "insert") {
      //   }
      resetOptions();

      modalConfig.title = "菜单权限设置";
      modalConfig.visible = true;
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.title = null;
      modalConfig.visible = false;
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const handleOk = () => {
      formRef.value
        .validateFields()
        .then((res) => {
          saveOrUpdatePermission(formState).then((res) => {
            const type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            handleCancel();
            context.emit("handleUpdateTable");
          });
        })
        .catch((err) => {
          if (err && err.errorFields) {
            const [errText] = err.errorFields[0].errors;
            Toast("warning", errText, 3);
          }
        });
    };

    // 选择未添加的路由
    const handleSelectDeduplica = (e) => {
      console.log(e);
      const selectItem = routerOptions.deduplica.find((f) => f.name === e);

      Object.keys(formState).forEach((key) => {
        if (selectItem && selectItem[key]) {
          formState[key] = selectItem[key];
        } else {
          formState[key] = null;
        }
      });
      console.log(selectItem);
    };

    return {
      routerOptions,
      formState,
      rules,
      showModal,
      handleCancel,
      handleOk,
      modalConfig,
      deduplica,
      handleSelectDeduplica,
    };
  },
});
</script>
    